/**
 * 録音BlobをそのままMP4/WebMでダウンロードする
 * @param {string} audioUrl - blob URL
 * @param {string} filename - ダウンロードファイル名（拡張子なし）
 */
export async function downloadAudio(audioUrl, filename = 'ondoku') {
  const response = await fetch(audioUrl);
  const blob = await response.blob();
  const ext = blob.type.includes('mp4') ? 'mp4' : 'webm';
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.${ext}`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
